"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 34 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M6.6066 27.82C0.748738 21.9621 0.748738 12.4646 6.6066 6.60678C12.4645 0.748913 21.9619 0.748913 27.8198 6.60678C33.6777 12.4646 33.6777 21.9621 27.8198 27.82L18.539 37.1008C17.8068 37.833 16.6196 37.833 15.8874 37.1008L6.6066 27.82Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M6.07627 6.07645C-0.0744858 12.2272 -0.0744858 22.1996 6.07627 28.3503L15.357 37.6311C16.3822 38.6562 18.0442 38.6562 19.0694 37.6311L28.3501 28.3503C34.5009 22.1996 34.5009 12.2272 28.3501 6.07645C22.1994 -0.0743099 12.227 -0.0743099 6.07627 6.07645Z",
      stroke: "currentColor",
      strokeOpacity: "0.5",
      strokeWidth: "1.5"
    })]
  });
};

exports.default = Icon;